var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "alert-card pa-2 pl-3",
      staticStyle: {
        display: "inline-block",
        width: "100%",
        "min-height": "205px",
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "v-row",
            { staticClass: "mx-0", attrs: { justify: "space-between" } },
            [
              _c("div", { staticStyle: { "font-size": "15px" } }, [
                _c("i", {
                  staticClass: "mr-1 mt-1 icon-price-guard-21x25 primary--text",
                }),
                _c("p", { staticClass: "mb-0 d-inline-flex" }, [
                  _vm._v(_vm._s(_vm.card.identity) + " : "),
                ]),
                _c("p", { staticClass: "mb-0 d-inline-flex" }, [
                  _vm._v(_vm._s(_vm.card.symbol)),
                ]),
              ]),
            ]
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pg-card-text pr-0 pb-0", attrs: { cols: "4" } },
                [
                  _c("p", [_vm._v("Insert Time :")]),
                  _c("p", [_vm._v("Status :")]),
                  _c("p", [_vm._v("Timestamp :")]),
                  _c("p", [_vm._v("Date time :")]),
                  _c("p", [_vm._v("Expires in :")]),
                  _vm.card.showMore
                    ? _c("div", [
                        _c("p", [_vm._v("Bid :")]),
                        _c("p", [_vm._v("Ask :")]),
                        _c("p", [_vm._v("Spread :")]),
                        _c("p", [_vm._v("Digits :")]),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "v-col",
                { staticClass: "pg-card-text px-0 pb-0", attrs: { cols: "8" } },
                [
                  _c("p", { staticClass: "title-color" }, [
                    _vm._v(_vm._s(_vm.card.insertTime)),
                  ]),
                  _c("p", [_vm._v(_vm._s(_vm.card.status))]),
                  _c("p", { staticClass: "title-color" }, [
                    _vm._v(_vm._s(_vm.card.timestampInMillis)),
                  ]),
                  _c("p", { staticClass: "title-color" }, [
                    _vm._v(_vm._s(_vm.card.datetime)),
                  ]),
                  _c("p", { staticClass: "title-color" }, [
                    _vm._v(_vm._s(_vm.card.expires_at)),
                  ]),
                  _vm.card.showMore
                    ? _c("div", [
                        _c("p", [_vm._v(_vm._s(_vm.card.bid))]),
                        _c("p", [_vm._v(_vm._s(_vm.card.ask))]),
                        _c("p", [_vm._v(_vm._s(_vm.card.spread))]),
                        _c("p", [_vm._v(_vm._s(_vm.card.digits))]),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticClass: "px-1 mt-1 remove-btn-text-transform",
              staticStyle: { "margin-left": "-6px" },
              attrs: { text: "", small: "" },
              on: {
                click: function ($event) {
                  _vm.card.showMore
                    ? _vm.$emit("show-less")
                    : _vm.$emit("show-more")
                },
              },
            },
            [
              _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                _vm._v(
                  _vm._s(
                    _vm.card.showMore
                      ? "fa-chevron-circle-up"
                      : "fa-chevron-circle-down"
                  )
                ),
              ]),
              _c(
                "p",
                {
                  staticClass: "ml-1 mb-0",
                  staticStyle: { "font-size": "14px", "margin-top": "1px" },
                },
                [_vm._v(_vm._s(_vm.card.showMore ? "Show less" : "Show more"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }